import { useEffect, useLayoutEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import AdminContainer from "./../AdminContainer/AdminContainer";
import AuthContainer from "../AuthContainer/AuthContainer";
import PublicContainer from "../PublicContainer/PublicContainer";
import WaiterContainer from "../WaiterContainer/WaiterContainer";
import NotFoundPage from "./../../components/Page/NotFoundPage/NotFoundPage";
import PreLoader from "../../helpers/PreLoader/PreLoader";
import CreateNotification from "../../helpers/CreateNotification/CreateNotification";
import NotificationListener from "../../helpers/NotificationListener/NotificationListener";
import { decodeJWT, getCookies } from "../../utils";
import {
  clearUserAction,
  setUserAction,
} from "../../redux/actions/userActions/userActions";
import { setSocketActions } from "./../../redux/actions/socketActions/socketActions";
import { setMetaAction } from "../../redux/actions/metaActions/metaActions";

const App = () => {
  const dispatch = useDispatch();

  const { pathname } = useLocation();

  const accessToken = getCookies("accessToken");

  useLayoutEffect(() => {
    dispatch(setMetaAction());
  }, []);

  useEffect(() => {
    if (accessToken) {
      const decodedToken = decodeJWT(accessToken);
      const dateNow = Date.now() / 1000;

      if (decodedToken?.exp < dateNow) dispatch(clearUserAction());
      else dispatch(setUserAction(accessToken));
    }
  });

  useEffect(() => {
    if (accessToken) {
      // Connect with Socket IO
      dispatch(setSocketActions(accessToken));
    }
  }, [accessToken]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <>
      <PreLoader />
      <NotificationListener />
      <CreateNotification />
      <Routes>
        {/* Admin Container */}
        <Route path="/admin/*" element={<AdminContainer />} />
        {/* Waiter Container */}
        <Route path="/waiter/*" element={<WaiterContainer />} />
        {/* Public Container */}
        <Route path="/auth/*" element={<AuthContainer />} />
        {/* Public Container */}
        <Route path="/*" element={<PublicContainer />} />
        {/* Not Found Component */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default App;
